export const newsCards = {
  by: "By {{name}}",
};
